import { VpsRoles } from '@dfg/brahma-types';

export const ROLE_MAPPING: Record<string, VpsRoles> = {
  ROLE_CLAIM_VALIDATOR: VpsRoles.siteVerification,
  ROLE_OTHER_VERIFICATION: VpsRoles.otherVerification
};

export const ROLE_TO_ROLE_NAME: Record<VpsRoles, string> = {
  [VpsRoles.siteVerification]: 'Site Verification',
  [VpsRoles.otherVerification]: 'Other Verification'
};

export const ROLE_TO_PROCESS: Record<VpsRoles, string> = {
  [VpsRoles.siteVerification]: 'Site Verification',
  [VpsRoles.otherVerification]: 'Other Verification'
};

export enum IA_VERIFIER_VIEW {
  IA = 'IA',
  OPS = 'OPS',
  VENDOR = 'VENDOR'
}

export enum UPLOAD_RESTRICTION {
  CAMERA_ONLY = 'camera-only',
  GALLERY_AND_CAMERA = 'gallery-and-camera'
}

export const CAMERA_ONLY_FILE_TYPES: string[] = ['jpg', 'jpeg', 'png', 'webp'];
export const VERIFIER_PORTAL_DEFAULT_FILE_TYPES: string[] = [
  'jpg',
  'jpeg',
  'png',
  'pdf',
  'webp'
];

export enum GEOLOCATION_ACTION {
  SET_GEOLOCATION_LOADING = 'SET_GEOLOCATION_LOADING',
  SET_GEOLOCATION_POSITION = 'SET_GEOLOCATION_POSITION',
  SET_GEOLOCATION_ERROR = 'SET_GEOLOCATION_ERROR',
  SET_GEOLOCATION_PERMISSION = 'SET_GEOLOCATION_PERMISSION',
  CLEAR_GEOLOCATION_ERROR = 'CLEAR_GEOLOCATION_ERROR'
}

export type GeolocationPermissionStatus =
  | 'granted'
  | 'denied'
  | 'prompt'
  | null;
